import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Brochure = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 14.5h8M8 17h5.333m-7.4-14h12.134c.515 0 .933.434.933.969V20c0 .535-.418 1-.933 1H5.933C5.418 21 5 20.535 5 20V3.969c0-.535.418-.97.933-.97M13.2 7c-.257 0-.509.08-.722.23a1.34 1.34 0 0 0-.478.607 1.34 1.34 0 0 0-.478-.608A1.27 1.27 0 0 0 10.8 7c-.358.032-.69.203-.931.479-.24.276-.372.636-.367 1.008 0 1.63 2.166 2.955 2.5 2.955.332 0 2.499-1.325 2.499-2.955a1.5 1.5 0 0 0-.368-1.009A1.4 1.4 0 0 0 13.2 7"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Brochure) as SvgIcon;
export { ForwardRef as ReactComponent };
